export default function AlgorithmModuleCard({
  module,
  onChange,
  onDelete
}) {

  function update(field, value) {
    onChange({
      ...module,
      [field]: value
    });
  }


  function updateSetting(key, value) {

    onChange({
      ...module,
      settings: {
        ...(module.settings || {}),
        [key]: value
      }
    });

  }


  return (
    <div
      className="
        bg-black/30
        border
        border-green-500/20
        rounded-xl
        p-5
        mb-4
      "
    >

      <div className="flex justify-between items-center">

        <h3 className="text-green-300 font-bold text-lg">
          {module.module_name}
        </h3>


        <div className="flex items-center gap-3">

          <label className="flex items-center gap-2 text-gray-400">

            Enabled

            <input
              type="checkbox"
              checked={module.enabled === 1}
              onChange={(e) =>
                update(
                  "enabled",
                  e.target.checked ? 1 : 0
                )
              }
            />

          </label>


          <button
            onClick={onDelete}
            className="
              px-2
              py-1
              rounded-lg
              bg-red-600
              hover:bg-red-500
              text-white
              font-bold
            "
          >
            X
          </button>

        </div>

      </div>


      <div className="mt-4">

        <label className="block text-gray-400 mb-2">
          Weight
        </label>


        <input
          type="number"
          value={module.weight ?? ""}
          onChange={(e)=>
            update(
              "weight",
              Number(e.target.value)
            )
          }
          className="
            w-full
            bg-gray-800
            rounded-lg
            px-3
            py-2
          "
        />

      </div>


      {Array.isArray(module.settingsSchema) &&
        module.settingsSchema.length > 0 && (

        <div className="mt-5">

          <h4 className="text-green-300 font-bold mb-3">
            Settings
          </h4>


          {module.settingsSchema.map(setting => (

              <div
                key={setting.key}
                className="mb-3"
              >

                <label className="block text-gray-400 mb-2">
                  {setting.label}
                </label>


                <input
                  type="number"
                  value={
                      module.settings?.[setting.key] ?? ""
                  }
                  onChange={(e)=>
                    updateSetting(
                        setting.key,
                        Number(e.target.value)
                    )
                  }
                  className="
                    w-full
                    bg-gray-800
                    rounded-lg
                    px-3
                    py-2
                  "
                />

              </div>

            )
          )}

        </div>

      )}

    </div>
  );
}